import { defineStore } from "pinia";
import storage from '../utils/Storage';
import type { ICirrusReaderBookmarkData } from "../shared/CirrusReaderModel";

interface CirrusBookmarksState {
    bookmarks: ICirrusReaderBookmarkData[]
}

export const useCirrusBookmarksStore = defineStore('cirrusBookmarks', {
  state: (): CirrusBookmarksState => ({
    bookmarks: [],
  }),
  actions: {
    addBookmark(bookmark: ICirrusReaderBookmarkData){
        this.bookmarks.push(bookmark);
    },
    deleteBookmark(locator: string) {
        this.bookmarks = this.bookmarks.filter((bookmark) => bookmark.locator !== locator);
    }
  },
  persist: {
      pick: [
        'bookmarks'
      ],
      storage
    }
});
